import type { LocalizationContext } from '../localization'

/**
 * Labels a crop key for display. A built-in crop's key is its `CropType`, which has a translation; a
 * custom crop's key is the grower's own name for it, which is shown as entered.
 */
export const translateCropKey = ({
  cropKey,
  t
}: {
  cropKey: string
  t: LocalizationContext['t']
}): string => t(($) => $.crops[cropKey as keyof typeof $.crops], { defaultValue: cropKey })
